import customerDependantService from "../services/customerDependant.service";

const customerDependants = {
    namespaced: true,
    state: {
        consentSmsStatuses: null,
    },
    actions: {
        //CREATE
        create(_, formData) {
            return customerDependantService.create(formData);
        },
        //READ
        getOne(_, id) {
            return customerDependantService.getOne(id);
        },

        async getConsentSmsStatuses({ commit, state, getters }) {
            if (state.consentSmsStatuses === null) {
                var response = await customerDependantService.getConsentSmsStatuses();
                commit("setConsentSmsStatuses", response.data);
            }
            return getters.consentSmsStatuses;
        },

        //UPDATE
        sendconsentsms(_, params) {
            return customerDependantService.sendconsentsms(params.customerDependantId);
        },
        update(_, params) {
            return customerDependantService.update(params.id, params.formData);
        },

        //DELETE
        delete(_, id) {
            return customerDependantService.delete(id);
        },
    },
    getters: {
        consentSmsStatuses: (state) => state.consentSmsStatuses
    },
    mutations: {
        setConsentSmsStatuses(state, types) {state.consentSmsStatuses = types;},

        
    },
};

export default customerDependants;
